import currenciesAPI from '@/api/currencies'

export const getCurrencyList = ({ commit }) => {
  return new Promise((resolve, reject) => {
    currenciesAPI.getCurrencyListAPI(currencyList => {
      commit('setCurrencyList', currencyList)
      resolve()
    })
  })
}

export const getCurrentCurrencyId = ({ commit }) => {
  return new Promise((resolve, reject) => {
    currenciesAPI.getCurrentCurrencyIdAPI(currencyId => {
      commit('setCurrentCurrencyId', currencyId)
      resolve()
    })
  })
}

export const setCurrentCurrencyId = ({ commit, dispatch }, param) => {
  currenciesAPI.setCurrentCurrencyIdAPI(category => {
    dispatch('getCurrentCurrencyId', '')
  }, param)
}



// WEBPACK FOOTER //
// ./src/store/modules/currencies/actions.js